var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"guide-content"},[_c('div',{staticClass:"news_title"},[_vm._v("\n    "+_vm._s(this.arcitleData && this.arcitleData[0] && this.arcitleData[0]["abstracts"]
        ? this.arcitleData[0]["abstracts"]
        : "")+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"content",style:({ paddingLeft: '24px', width: '100%' }),domProps:{"innerHTML":_vm._s(
      this.arcitleData && this.arcitleData[0] && this.arcitleData[0]['html']
        ? this.arcitleData[0]['html']
        : ''
    )}})])
}
var staticRenderFns = []

export { render, staticRenderFns }